import React, { createContext, useContext } from 'react';

interface DialogFormContextValue {
  /** Called when the form's Cancel/Discard button is pressed. */
  onClose: () => void;
}

const DialogFormContext = createContext<DialogFormContextValue | null>(null);

/**
 * Hook used by `MyToolbar` to know whether it lives inside a popup
 * dialog. When non-null, Cancel closes the dialog instead of
 * redirecting to the list page.
 */
export const useDialogForm = (): DialogFormContextValue | null =>
  useContext(DialogFormContext);

export const DialogFormProvider: React.FC<{
  onClose: () => void;
  children: React.ReactNode;
}> = ({ onClose, children }) => (
  <DialogFormContext.Provider value={{ onClose }}>
    {children}
  </DialogFormContext.Provider>
);
